<div class="tw-w-full tw-h-14 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-6 tw-bg-black">
  <div class="tw-absolute tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
  </div>
  <span class="tw-font-body tw-font-bold tw-text-300 tw-text-white" i18n="@@checkup">Check-up</span>
</div>
<div class="tw-w-full tw-py-9 tw-px-6 tw-font-body" [ngClass]="isTextareaFocused ? 'tw-mt-0' : 'tw-mt-20'">
  <h2 class="tw-text-600 tw-font-bold tw-text-center" i18n="@@describeYourConcern">Describe your concern <br/> so the doctor can guide you</h2>
  <p class="tw-text-300 tw-text-gray-500 tw-mt-2 tw-mb-10 tw-text-center" i18n="@@doctorWillAnalyseThisAndCallYou">Doctor will analyse this and call you</p>
  <textarea class="tw-w-full tw-h-32 tw-border-2 tw-bg-gray-80 tw-rounded-3 tw-p-2 tw-border-none"
    placeholder="Write here"
    [(ngModel)]="userQuery"
    (focus)="onTextareaFocus()"
    (blur)="onTextareaBlur()"
    (ngModelChange)="handleOnChange()"
    i18n-placeholder="@@writeHere">
  </textarea>
  <div class="tw-flex tw-items-start tw-gap-1.5" [ngClass]="{'tw-visible': invalidUserInputError?.length, 'tw-invisible': !invalidUserInputError?.length}">
    <img src="/assets/images/warn-err.png" class="tw-w-4 tw-mt-0.5" />
    <p class="tw-text-orange-500 tw-text-200 tw-font-normal tw-font">
      {{invalidUserInputError}}
    </p>
  </div>
  <button class="tw-w-full tw-bg-teal-600 tw-text-white tw-rounded-3 tw-py-3 tw-text-center tw-font-bold tw-text-500" [ngClass]="isTextareaFocused ? 'tw-mt-3' : 'tw-mt-20'" (click)="onContinue()" i18n="@@continue">Continue</button>
</div>
